<script setup lang="ts">
import type { IProps } from './Files.types'
import { EFILE_DOWNLOAD_VARIANT } from '~/components/UiFileDownload/UiFileDownload.types'
defineProps<IProps>()

</script>

<template>
  <div
    class="investorFiles"
  >
    <p class="investorFiles__title">
      {{ $t('investor.files.title') }}
    </p>

    <div class="investorFiles__flexbox">
      <UiFileDownload
        v-for="file in files"
        :key="file.label"
        :variant="EFILE_DOWNLOAD_VARIANT.DEFAULT"
        :label="file.label"
        :format="file.format"
        :size="file.size"
        :button="{
          to: file.url,
          text: $t('investor.files.seeFile'),
          size: 'small',
          target: '_blank'
        }"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.investorFiles {
  margin-top: 4.8rem;

  &__title {
    @include h10;
    padding-bottom: 2.4rem;
  }

  &__flexbox {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
  }

  @include atS {
    margin-top: 6.4rem;
  }
}
</style>
